import * as THREE from 'three';

export class Tree {
  static create(): THREE.Group {
    const tree = new THREE.Group();
    
    const trunk = new THREE.Mesh(
      new THREE.CylinderGeometry(0.4, 0.6, 2, 6), // Increased trunk width and decreased height
      new THREE.MeshPhongMaterial({ color: 0x8b4513 })
    );
    
    const coneHeight = 3;
    const coneRadius = 3;
    const coneSegments = 6;
    
    const top1 = new THREE.Mesh(
      new THREE.ConeGeometry(coneRadius, coneHeight, coneSegments),
      new THREE.MeshPhongMaterial({ color: 0x2d5a27 })
    );
    top1.position.y = 2; // Adjusted position
    
    const top2 = new THREE.Mesh(
      new THREE.ConeGeometry(coneRadius * 0.8, coneHeight * 0.8, coneSegments),
      new THREE.MeshPhongMaterial({ color: 0x3a6a34 })
    );
    top2.position.y = 3.8; // Adjusted position
    
    const top3 = new THREE.Mesh(
      new THREE.ConeGeometry(coneRadius * 0.6, coneHeight * 0.6, coneSegments),
      new THREE.MeshPhongMaterial({ color: 0x4d7a41 })
    );
    top3.position.y = 5.2; // Adjusted position
    
    tree.add(trunk, top1, top2, top3);
    tree.rotation.y = Math.random() * Math.PI * 2;
    
    return tree;
  }
}